import { cn } from "@/lib/utils";
import { FaSpinner } from "react-icons/fa";

interface SpinnerProps {
  className?: string;
}

const Spinner = (props: SpinnerProps) => {
  return (
    <FaSpinner
      data-testid="spinner"
      className={cn("animate-spin bg-transparent", props.className)}
    />
  );
};

export default Spinner;
